module.exports = __webpack_public_path__ + "img/Icon_home_register.9d847dc6.svg";